import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        subHeading: {
            color: '#2C2F31',
            fontWeight: 600,
            marginBottom: theme.spacing(2),
        },
        cardHeader: {
            fontWeight: 600,
            fontSize: 16,
            color: '#020202',
        },
        cardLine: {
            '@media (max-width: 767px)':{
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            '@media (min-width: 768px)':{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }
        },
        cardItem: {
            flexGrow: 1,
        },
        spacing: {
            padding: theme.spacing(1),
        },
        lastCard: {
            maxWidth: '30vw',
        },
        successTextColor: {
            color: theme.palette.success.main,
        },
        errorTextColor: {
            color: theme.palette.error.main,
        },
        orlabel: {
            margin: theme.spacing(0, 2),
            fontSize: 16,
        },
    })
);